// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vts-tabs{overflow:hidden;border:1px solid #565454;border-radius:.25rem}.vts-tabs [role=tablist]{display:flex}.vts-tabs [role=tab]{font-size:1.4em;flex-grow:1;border:1px solid #555654;padding:.5rem}.vts-tabs [role=tab][aria-selected=true]{border-bottom-color:#93e5a7;background:#d4edda;font-weight:700}.vts-tabs [role=tabpanel]{background:#fff}", ""]);
// Exports
module.exports = exports;
